export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
